var EnhanceCartCheckout = function () {
  var self = this;
  this.initCartCount = function () {
    document.addEventListener("click", (e) => {
      const { target } = e;
      if (target.matches(".cart__number-next") || target.closest(".cart__number-next")) {
        e.preventDefault();
        const btnNext = target.classList.contains("cart__number-next") ? target : target.closest(".cart__number-next");
        const btnPrev = btnNext.closest(".cart__number").querySelector(".cart__number-prev");
        const input = btnNext.closest(".cart__number").querySelector("input");
        initChangeValue(1, input, btnPrev);
      }

      if (target.matches(".cart__number-prev") || target.closest(".cart__number-prev")) {
        e.preventDefault();
        const btnPrev = target.classList.contains("cart__number-prev") ? target : target.closest(".cart__number-prev");
        const input = btnPrev.closest(".cart__number").querySelector("input");
        initChangeValue(-1, input, btnPrev);
      }
    });

    const initChangeValue = (counter, input, btnDec) => {
      const currentValue = parseInt(input.value) + parseInt(counter);
      input.value = currentValue;
      self.updateCart(input);
      if (btnDec) {
        if (currentValue <= 1) {
          btnDec.classList.add("disabled");
        } else {
          btnDec.classList.remove("disabled");
        }
      }
    };
    document.querySelectorAll(".cart__number").forEach((holder) => {
      var btnDec = holder.querySelector(".cart__number-prev");
      var btnInc = holder.querySelector(".cart__number-next");
      var input = holder.querySelector("input");
      var currentValue = parseInt(input.value);

      if (currentValue <= 1) {
        btnDec.classList.add("disabled");
      } else {
        btnDec.classList.remove("disabled");
      }
    });
  };
  this.init = function () {
    let draftorder_id = undefined;
    if (/[?&]id=/.test(location.search)) {
      let params = new URLSearchParams(window.location.search);
      draftorder_id = params.get("id");
    }

    CustomTrampolineATC.addToCart(draftorder_id)
      .then(function (res) {
        return res;
      })
      .catch(function (e) {
        console.log(e);
      })
      .then((res) => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((obj) => {
            return obj.json();
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .then((obj) => {
            window.history.replaceState(null, "", window.location.pathname);
            self.updateCheckoutBtn(obj);
            self.refreshCartItems(obj);
            
            let freeItem = `<div class="checkout__item free-item" data-type="" data-variant="" data-sku="">
              <div class="checkout__wrap">
                <div class="checkout__img">
                  <span class="checkout__num">1</span>
                  <a href="">
                    <img class="cart__image hide" src="https://cdn.shopify.com/s/files/1/0242/3016/6624/files/Flexrstep-Render_dd3b0651-b75e-4333-a6d9-3ec8ba454c7e.png?v=1729615243" loading="lazy" alt="" width="" height="" data-cart-item-image="">
                  </a>
                </div>
                <div class="checkout__text">
                  <span class="checkout__title"> Flexrstep</span>
                  <p class="stock-message">Cyber Monday Promotion</p>
                  <div class="discount-message"></div>
                </div>
              </div>
              <div class="checkout__price">
                <span class="checkout__old-price"></span>
                <div class="position-relative checkout__new">
                  <div class="price">FREE</div>
                </div>
              </div>
            </div>`;
            let hasCustomTrampoline = false;
            let isfreeitemavailable = document.querySelector(".checkout__list .checkout__item.free-item");
            obj.items.forEach((item, index) => {
              if (CUSTOMTRAMPOLINES.includes(item.sku)) {
                hasCustomTrampoline = true;
              }
            });
            
            obj.items.forEach((item, i) => {
              let prodList = document.querySelector('.cart__list [data-product-id="' + item.product_id + '"]');

              if (prodList != null) {
                labels = prodList.closest(".cart__item").querySelector(".labels-wrap");

                prodList.querySelector(".add-to-cart-wrap").innerHTML = `<div class="cart__number d-flex flex-wrap justify-content-end" action="#">
                  <a href="#" class="cart__number-prev ${parseInt(item.quantity) <= 1 ? "disabled" : ""}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="1.994" viewBox="0 0 10.183 1.994">
                      <path id="Path_18" data-name="Path 18" d="M9.186,3.91H1A1,1,0,1,0,1,5.9H9.186a1,1,0,1,0,0-1.993Z"
                        transform="translate(0 -3.91)" fill="#fff"></path>
                    </svg>
                  </a><input type="text" value="${item.quantity}" class="qty-input">
                  <a href="#" class="cart__number-next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="10.183" viewBox="0 0 10.183 10.183">
                      <path id="Path_18" data-name="Path 18"
                        d="M9.186,3.91H6.047V1A1,1,0,1,0,4.053,1V3.91H1A1,1,0,1,0,1,5.9H4.053V9.186a1,1,0,0,0,1.994,0V5.9H9.186a1,1,0,1,0,0-1.993Z"
                        fill="#fff"></path>
                    </svg>
                  </a>
                </div>`;
                if (prodList.querySelector(".select-wrapper") != null) {
                  prodList.querySelector(".select-wrapper").style.visibility = "hidden";
                  prodList.setAttribute("data-variant-id", item.variant_id);
                  prodList.querySelector(".select-wrapper select").value = item.variant_title;
                  prodList.querySelector(".select-wrapper select").onchange();
                }

                self.updatedBadge(obj, labels, item.product_id);
              }
            });
            self.updateCartItemMeta();
            new InstallationUpdate();
          });
      });
    this.initCartCount(); //document.addEventListener('click', this.updateCart);
    document.addEventListener("click", this.deleteCartItem);
    document.addEventListener("click", this.addToCart);
  };
  this.updateCartItemMeta = function () {
    fetch("/cart?view=metafields.json")
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((obj) => {
        let elements = document.querySelectorAll(".cart__list .label__included");
        if (elements.length) {
          for (var i = 0; i < elements.length; i++) {
            elements[i].remove();
          }
        }
        let bundles_items = [];
        obj.items.forEach((item, index) => {
          if (item.including_installation) {
            bundles_items.push(item.sku);
          }
          let variant_item = document.querySelector('.checkout-item-listing [data-variant="' + item.variant_id + '"] .stock-message');
          let variant_cross_price = document.querySelector('.checkout-item-listing [data-variant="' + item.variant_id + '"] .checkout__old-price');
          if (variant_item) {
            variant_item.innerHTML = item.stock_message !== null ? item.stock_message_label + " " + item.stock_message : "In Stock";
          }

          if (variant_cross_price && item.compare_at_price) {
            variant_cross_price.innerHTML = Shopify.formatMoney(
              item.compare_at_price
            );
          }

          if (item.choose_accessories !== null) {
            item.choose_accessories.forEach((cartItem, index) => {
              let product_id = cartItem.accessory.replace("gid://shopify/Product/", "");
              let labels = document.querySelector('.cart__list [data-product-id="' + product_id + '"]');
              if (labels !== null) {
                let _label_included = labels.closest(".cart__item").querySelector(".labels-wrap");
                if (labels.closest(".cart__item").querySelector(".labels-wrap .label__included") == null) {
                  _label_included.insertAdjacentHTML("beforeend",'<span class="cart__label label label__included">INCLUDED</span>');
                }
              }
            });
          }
        });
        CheckoutPromo.upateBundleStatus(bundles_items);
      });
  };
  this.updateLineItem = function (formData) {
    return new Promise(function (resolve, reject) {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((obj) => {
          resolve(obj);
        });
    });
  };

  this.addToCart = function (e) {
    if (e.target.classList.contains("btn-add")) {
      e.preventDefault();
      let current = e.target;
      let labels = e.target
        .closest(".cart__item")
        .querySelector(".labels-wrap");
      let productid =
        current.parentElement.parentElement.getAttribute("data-product-id");

      let formData = {
        items: [
          {
            id: current.parentElement.parentElement.getAttribute(
              "data-variant-id"
            ),
            quantity: 1,
            properties: {
              _PR_Page_ID:
                current.parentElement.parentElement.getAttribute("data-pr-id"),
            },
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((obj) => {
          if (
            current.parentElement.parentElement.querySelector(
              ".select-wrapper"
            ) != null
          ) {
            current.parentElement.parentElement.querySelector(
              ".select-wrapper"
            ).style.visibility = "hidden";
          }
          current.parentElement.innerHTML = `<div class="cart__number d-flex flex-wrap justify-content-end" action="#">
          <a href="#" class="cart__number-prev disabled">
            <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="1.994" viewBox="0 0 10.183 1.994">
              <path id="Path_18" data-name="Path 18" d="M9.186,3.91H1A1,1,0,1,0,1,5.9H9.186a1,1,0,1,0,0-1.993Z"
                transform="translate(0 -3.91)" fill="#fff"></path>
            </svg>
          </a><input type="text" value="1" class="qty-input">
          <a href="#" class="cart__number-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="10.183" viewBox="0 0 10.183 10.183">
              <path id="Path_18" data-name="Path 18"
                d="M9.186,3.91H6.047V1A1,1,0,1,0,4.053,1V3.91H1A1,1,0,1,0,1,5.9H4.053V9.186a1,1,0,0,0,1.994,0V5.9H9.186a1,1,0,1,0,0-1.993Z"
                fill="#fff"></path>
            </svg>
          </a>
        </div>`;

          fetch(window.Shopify.routes.root + "cart.js")
            .then((obj) => {
              return obj.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .then((obj) => {
              self.updateCheckoutBtn(obj);
              self.refreshCartItems(obj);
              self.updatedBadge(obj, labels, productid);
              self.updateCartItemMeta();
            });
        });
    }
  };

  this.updatedBadge = function (obj, labels, productid) {
    let _label_added = labels.querySelector(".label__added");
    let _count = obj.items.reduce(
      (accumulator, item) =>
        item.product_id == productid
          ? accumulator + item.quantity
          : accumulator,
      0
    );
    if (typeof _label_added != "undefined" && _label_added != null)
      _label_added.remove();
    if (_count > 0) {
      labels.insertAdjacentHTML(
        "beforeend",
        `<span class="cart__label label bg-success label__added">${_count} ADDED</span>`
      );
    }
  };

  this.updateCart = function (input) {
    let _cart_info = input.closest(".cart__text-info");
    if (_cart_info == null) {
      _cart_info = input.closest(".cart-info-box");
    }

    let labels = input.closest(".cart__item").querySelector(".labels-wrap");
    let productid = _cart_info.getAttribute("data-product-id");
    let variantid = _cart_info.getAttribute("data-variant-id");
    let qty = parseInt(_cart_info.querySelector(".qty-input").value);
    let formData = {
      updates: {},
    };
    formData.updates[variantid] = qty;

    self.updateLineItem(formData).then((obj) => {
      self.updateCheckoutBtn(obj);
      self.refreshCartItems(obj);
      self.updatedBadge(obj, labels, productid);
      self.updateCartItemMeta();
      let installationProduct = "installation";
      new InstallationUpdate(installationProduct,false);
    });
  };
  this.updateCheckoutBtn = function (obj) {
    if (obj.items.length == 0) {
      document.querySelector(".btn-checkout")?.setAttribute("disabled", "disabled");
    } else {
      document.querySelector(".btn-checkout")?.removeAttribute("disabled");
    }
  };
  this.deleteCartItem = function (e) {
    if (
      e.target.classList.contains("checkout__del") ||
      e.target.parentElement.classList.contains("checkout__del") ||
      e.target.parentElement.parentElement.classList.contains("checkout__del")
    ) {
      e.preventDefault();
      let variant_id = e.target
        .closest(".checkout__item")
        .getAttribute("data-variant");

      let sku = e.target.closest(".checkout__item").getAttribute("data-sku");

      let formData = {
        updates: {},
      };
      formData.updates[variant_id] = 0;
      let newCustomToolItems = 0;
      if (CUSTOMTRAMPOLINES.includes(sku) && document.querySelector(".checkout__list").hasChildNodes()) {
        document.querySelectorAll(".checkout__list .checkout__item")
          .forEach((item, index) => {
            let csku = item.getAttribute("data-sku");
            let cqty = item.querySelector(".checkout__num").innerHTML;
            if (CUSTOMTRAMPOLINES.includes(csku)) {
              newCustomToolItems += parseInt(cqty);
            }
          });
        let current_qty = e.target.closest(".checkout__item").querySelector(".checkout__num").innerHTML;
        newCustomToolItems = newCustomToolItems - parseInt(current_qty);
        formData.updates[customizationFeeID] = newCustomToolItems;
      }

      self.updateLineItem(formData).then((obj) => {
        self.updateCheckoutBtn(obj);
        self.updatePromocode(obj);
        let _cart_atc = document.querySelector('.cart__list [data-variant-id="' + variant_id + '"]');

        if (_cart_atc !== null) {
          let productid = _cart_atc.getAttribute("data-product-id");
          let labels = _cart_atc.closest(".cart__item").querySelector(".labels-wrap");
          _cart_atc.querySelector(".add-to-cart-wrap").innerHTML = `<a href="#" class="btn btn-primary btn-add">ADD</a>`;
          if (_cart_atc.querySelector(".select-wrapper") != null) {
            _cart_atc.querySelector(".select-wrapper").style.visibility = "visible";
          }
          self.updatedBadge(obj, labels, productid);
        }
        self.updateCartItemMeta();
        let installationProduct = "installation";
        new InstallationUpdate(installationProduct,false);
        e.target.closest(".checkout__item").remove();

        let trampolinesLength = document.querySelectorAll('.checkout__list .checkout__item[data-type="trampoline"], .checkout__list .checkout__item[data-type="Custom Trampoline"]').length;
        let installationItem = document.querySelector('.checkout__list .checkout__item[data-type="installation"]');
        if (trampolinesLength < 1) {
          installationItem?.remove();
          document.querySelector(".professional-install.cart__selected")?.classList.remove("cart__selected");
        }
        if (installationItem == null) {
          let originalprice = document.querySelector(".professional-install.cart__selected")?.querySelector(".price strong del")?.innerHTML;
          if (originalprice != null) {
            document.querySelector(".professional-install.cart__selected .price strong").innerHTML = originalprice;
          }
          document.querySelector(".professional-install.cart__selected")?.classList.remove("cart__selected");
        }

        document.querySelector(".checkout__subtotal-price").innerHTML =
          Shopify.formatMoney(obj.total_price) + " " + obj.currency;
        document.querySelector(".checkout__total-price .price").innerHTML =
          Shopify.formatMoney(obj.total_price);
        document.querySelector(
          ".checkout__total .checkout__total-price .price"
        ).innerHTML = Shopify.formatMoney(obj.total_price);
      });
    }
  };

  this.updatePromocode = function (obj) {
    CheckoutPromo.init(obj.items);
    if (localStorage.getItem("discountCode")) {
      EnhancePromocode.applyDiscount(localStorage.getItem("discountCode"), false);
    }
  };

  this.refreshCartItems = function (cart) {
    document.querySelector(".checkout__subtotal-price").innerHTML =
      Shopify.formatMoney(cart.total_price) + " " + cart.currency;
    document.querySelector(".checkout__total-price .price").innerHTML =
      Shopify.formatMoney(cart.total_price);
    document.querySelector(
      ".checkout__total .checkout__total-price .price"
    ).innerHTML = Shopify.formatMoney(cart.total_price);
    self.updatePromocode(cart);
    cart.items.forEach((item, index) => {
      let listing = document.querySelector(
        '.checkout-item-listing [data-variant="' + item.variant_id + '"]'
      );
      if (listing !== null) {
        listing.querySelector(".checkout__price .price").innerHTML =
          Shopify.formatMoney(item.final_line_price);
        listing.querySelector(".checkout__img .checkout__num").innerHTML =
          item.quantity;
        if( listing.querySelector(".checkout__qty select") ) {
          listing.querySelector(".checkout__qty select").value = item.quantity;
        }
        
      } else {
        let deletebtn = `<a href="#" class="checkout__del">
        <svg viewBox="0 0 13.5 14.291">
          <path id="svgexport-13"
            d="M12.336,5.33,11.849,14.4a.635.635,0,0,1-.628.6H3.278a.635.635,0,0,1-.628-.6L2.164,5.33A.629.629,0,1,1,3.42,5.267l.455,8.477h6.766L11.1,5.267a.621.621,0,1,1,1.24.063ZM14,3.23a.63.63,0,0,1-.628.628H1.128a.628.628,0,0,1,0-1.256H4.581V1.186a.454.454,0,0,1,.5-.471H9.417a.454.454,0,0,1,.5.471V2.6H13.37a.63.63,0,0,1,.63.628ZM5.68,2.6H8.82V1.815H5.68Zm.267,10.2a.587.587,0,0,0,.549-.6L6.34,5.424a.56.56,0,0,0-.565-.549.537.537,0,0,0-.534.565l.157,6.8a.57.57,0,0,0,.549.562Zm2.59,0a.556.556,0,0,0,.549-.549l.157-6.781a.55.55,0,0,0-1.1-.031l-.157,6.781a.553.553,0,0,0,.549.581Z"
            transform="translate(-0.5 -0.712)" fill="#626262" stroke="#cfd2d5" stroke-width="0"></path>
        </svg>
      </a>`;
        let _image_url = item.featured_image.url.imgURL("x190");
        if (item.product_type == "Custom Trampoline") {
          _image_url = item.properties._image_url;
        }

        let _html = `<div class="checkout__item" data-variant="${
          item.variant_id
        }" data-sku="${item.sku}">
          <div class="checkout__wrap">
            <div class="checkout__img">
              <span class="checkout__num">${item.quantity}</span>
              <a href="${item.url}">
                <img class="cart__image" src="${_image_url}" loading="lazy" alt="${
          item.featured_image.alt
        }" data-cart-item-image>
              </a>
            </div>
            <div class="checkout__text">
              <span class="checkout__title">${item.title}</span>
              <p class="stock-message"></p>
              <div class="discount-message"></div>
            </div>
          </div>
          <div class="checkout__qty">
            <span class="checkout__qty">
              <label for="checkout_qty1" class="d-inline-block mr-1">Qty:</label>
              <div class="select-holder">
                <select
                  class="js-choices"
                >
                    ${[1, 2, 3, 4, 5]
                      .map(
                        (i) => `
                    <option value="${i}" ${
                          item.quantity == i ? "selected" : ""
                        }>
                      ${i}
                    </option>`
                      )
                      .join("")}
                </select>
              </div>
            </span>
          </div>
          <div class="checkout__price">
            <span class="checkout__old-price"></span>
            <div class="position-relative checkout__new">
              <span class="price">${Shopify.formatMoney(
                item.final_line_price
              )}</span>
             ${
               item.handle != "customization-fee" &&
               item.handle != "customization-fee_new"
                 ? deletebtn
                 : ""
             }
            </div>
          </div>
        </div>`;
        document
          .querySelector(".checkout-item-listing .checkout__list")
          .insertAdjacentHTML("beforeend", _html);
      }
    });
    updateSidebarCart();
  };

  this.init();
};
new EnhanceCartCheckout();

// var InstallationUpdate = function (
//   selectDelivery = false,
//   hasInstallation = false,
//   installationProduct = "installation"
// ) {
//   this.init = function () {
//     function getCookie(name) {
//         var nameEQ = name + '=';
//         var ca = document.cookie.split(';');
//         for (var i = 0; i < ca.length; i++) {
//           var c = ca[i];
//           while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//           if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//         }
//         return null;
//     }
//     let cartContents = this.getCart();
//     let installation = this.getInstallation();
//     let estimator = null;
//     let postcode = getCookie("sft_postcode");
//     let sft_installation = getCookie("sft_installation");

//     Promise.all([installation, cartContents, estimator]).then((values) => {
//       let [installation, cart, estimator] = values;
//       let itemsToUpdate = {
//         updates: {},
//       };
//       let trampoline_count = cart.items.reduce(
//         (total, item) =>
//           item.product_type == "trampoline" ||
//           item.product_type == "Custom Trampoline" ||
//           item.product_type == "bundle trampoline"
//             ? total + item.quantity
//             : total,
//         0
//       );
      
//       //|| item.product_type == "bundle trampoline"
//       hasInstallation = !hasInstallation
//         ? cart.items.find((e) => e.handle === installationProduct)
//         : hasInstallation;

//       if (!hasInstallation && trampoline_count > 0) {
//         document
//           .querySelector(".enhance-checkout-cart")
//           ?.addEventListener("submit", function (e) {
//             e.preventDefault();
//             window.location.href = "/pages/select-delivery-installation";
//           });
//       }

//       let variants = installation.variants;

//       if (hasInstallation) {
//         itemsToUpdate.updates[variants[0].id] = trampoline_count;
//       }

//       if (sft_installation == "self") {
//         hasInstallation = true;
//       }

//       let update = this.updateCart(itemsToUpdate);
//       Promise.all([update, variants]).then((values) => {
//         let hasItem = values[0].items.find((e) => e.handle === "installation");
//         if (hasItem !== undefined) {
//           eraseSFTCookie("sft_installation");
//         }

//         let added_variant = null;
//         // if (!hasInstallation) {
//         //   document.querySelector(".step2 .btn-checkout")?.setAttribute("disabled", "disabled");
//         // } else {
//         //   document.querySelector(".step2 .btn-checkout")?.removeAttribute("disabled");
//         // }
//         if (values[0].items.find((e) => e.handle === installationProduct)) {
//           values[0].items.forEach((item, index) => {
//             if (item.handle == installationProduct) {
//               let installation = document.querySelector('.checkout-item-listing [data-variant="' +item.variant_id +'"]');
//               added_variant = item.variant_id;
//               if (installation !== null) {
//                 installation.querySelector(".checkout__num").innerHTML = item.quantity;
//                 let dropdownValue = installation.querySelector(".checkout__qty .choices__item--selectable");

//                 if (dropdownValue != null) {
//                   dropdownValue.innerHTML = item.quantity;
//                 }
//                 installation.querySelector(".price").innerHTML = `${Shopify.formatMoney(item.final_line_price)}`;
//               }
//               if (installation == null && selectDelivery) {
//                 this.updateInstallation(item);
//                 CheckoutPromo.init(values[0].items);
//                 if (localStorage.getItem("discountCode")) {
//                   EnhancePromocode.applyDiscount(
//                     localStorage.getItem("discountCode"),
//                     false
//                   );
//                 }
//               }
//             }
//           });
//         }

//         // values[1].forEach(function (item, index, arr) {
//         //   let install = document.querySelector('.checkout-item-listing [data-variant="' + item.id + '"]');
//         //   if (install && added_variant == null) {
//         //     install.remove();
//         //   }
//         // });
//         let subtotal = document.querySelector(".checkout__subtotal-price");
//         let total = document.querySelector(".checkout__total-price .price");
//         let checkout_total = document.querySelector(".checkout__total .checkout__total-price .price");

//         if (subtotal != null) {
//           subtotal.innerHTML = Shopify.formatMoney(values[0].total_price) + " " + values[0].currency;
//         }
//         if (total != null) {
//           total.innerHTML = Shopify.formatMoney(values[0].total_price);
//         }
//         if (checkout_total != null) {
//           checkout_total.innerHTML = Shopify.formatMoney(values[0].total_price);
//         }
//       });
//     });
//   };

//   this.addProfessionalInstall = function () {
//     this.getInstallation().then(function (response) {});
//   };

//   this.changeCart = function (formData) {
//     return fetch(window.Shopify.routes.root + "cart/change.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       })
//       .then((response) => {
//         return response;
//       });
//   };

//   this.updateCart = function (itemsToUpdate) {
//     return fetch(window.Shopify.routes.root + "cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(itemsToUpdate),
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       })
//       .then((response) => {
//         return response;
//       });
//   };

//   this.updateInstallation = function (item) {
//     let _html = `<div class="checkout__item" data-product-type="test" data-variant="${
//       item.variant_id
//     }">
//           <div class="checkout__wrap">
//             <div class="checkout__img">
//               <span class="checkout__num">${item.quantity}</span>
//               <a href="${item.url}">
//                 <img class="cart__image" src="${item.featured_image.url.imgURL(
//                   "x190"
//                 )}" loading="lazy" alt="${
//       item.featured_image.alt
//     }" data-cart-item-image>
//               </a>
//             </div>
//             <div class="checkout__text">
//               <span class="checkout__title">${item.title}</span>
//               <p class="stock-message"></p>
//               <div class="discount-message"></div>
//             </div>
//           </div>
//           <div class="checkout__price">
//             <span class="checkout__old-price"></span>
//             <div class="position-relative checkout__new">
//               <span class="price">${
//                 item.final_line_price == 0
//                   ? "FREE"
//                   : Shopify.formatMoney(item.final_line_price)
//               }</span>
//               <a href="#" class="checkout__del">
//               <svg viewBox="0 0 13.5 14.291">
//                 <path id="svgexport-13"
//                   d="M12.336,5.33,11.849,14.4a.635.635,0,0,1-.628.6H3.278a.635.635,0,0,1-.628-.6L2.164,5.33A.629.629,0,1,1,3.42,5.267l.455,8.477h6.766L11.1,5.267a.621.621,0,1,1,1.24.063ZM14,3.23a.63.63,0,0,1-.628.628H1.128a.628.628,0,0,1,0-1.256H4.581V1.186a.454.454,0,0,1,.5-.471H9.417a.454.454,0,0,1,.5.471V2.6H13.37a.63.63,0,0,1,.63.628ZM5.68,2.6H8.82V1.815H5.68Zm.267,10.2a.587.587,0,0,0,.549-.6L6.34,5.424a.56.56,0,0,0-.565-.549.537.537,0,0,0-.534.565l.157,6.8a.57.57,0,0,0,.549.562Zm2.59,0a.556.556,0,0,0,.549-.549l.157-6.781a.55.55,0,0,0-1.1-.031l-.157,6.781a.553.553,0,0,0,.549.581Z"
//                   transform="translate(-0.5 -0.712)" fill="#626262" stroke="#cfd2d5" stroke-width="0"></path>
//               </svg>
//             </a>
//             </div>
//           </div>
//         </div>`;

//     document.querySelector(".checkout-item-listing .checkout__list").insertAdjacentHTML("beforeend", _html);
//   };

//   this.getCart = function () {
//     return fetch(window.Shopify.routes.root + "cart.js")
//       .then((response) => response.json())
//       .then((data) => {
//         return data;
//       });
//   };

//   this.getInstallation = function () {
//     return fetch(window.Shopify.routes.root + "products/installation.js")
//       .then((response) => response.json())
//       .then((data) => {
//         return data;
//       });
//   };
//   // this.getSelfInstallation = function() {
//   //     return fetch(window.Shopify.routes.root + "products/self-install.js")
//   //         .then((response) => response.json())
//   //         .then((data) => {
//   //             return data;
//   //         });
//   // };
//   this.init();
// };

var InstallationUpdate = function (installationProduct = null, autoAdd = false, isInstallPage = false) {
  console.log("InstallationUpdate Loaded", installationProduct, autoAdd, isInstallPage);

  const VALID_INSTALLATIONS = ["installation", "installation-scotland"];
  const SELF_INSTALL = "self-install";

  /* ------------------------------
     COOKIE HELPERS
  ------------------------------ */
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  };

  const setCookie = (name, value, days = 7) => {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`;
  };

  const eraseCookie = (name) => {
    document.cookie = name + "=; Max-Age=-99999999; path=/";
  };

  /* ------------------------------
     TOTALS HELPER
  ------------------------------ */
  this.updateTotals = function (cart) {
    const subtotal = document.querySelector(".checkout__subtotal-price");
    const total = document.querySelector(".checkout__total-price .price");
    const checkoutTotal = document.querySelector(".checkout__total .checkout__total-price .price");

    if (subtotal) subtotal.innerHTML = Shopify.formatMoney(cart.total_price);
    if (total) total.innerHTML = Shopify.formatMoney(cart.total_price);
    if (checkoutTotal) checkoutTotal.innerHTML = Shopify.formatMoney(cart.total_price);
  };

  /* ------------------------------
     INIT
  ------------------------------ */
  this.init = async function (doAdd = autoAdd) {
    const sft_installation = getCookie("sft_installation");
    const cart = await this.getCart();

    const trampoline_count = cart.items.reduce(
      (total, item) =>
        ["trampoline"].includes(item.product_type)
          ? total + item.quantity
          : total,
      0
    );

    const cartInstallation = cart.items.find((i) => i.handle === "installation");
    const cartScotland = cart.items.find((i) => i.handle === "installation-scotland");

    const checkoutButton = document.querySelector(".enhance-checkout-cart .btn-checkout");

    /* ------------------------------
       UI DISABLE ONLY (INSTALL PAGE ONLY)
    ------------------------------ */
    if (isInstallPage) {
      const shouldDisableCheckout =
        trampoline_count > 0 &&
        !cartInstallation &&
        !cartScotland &&
        sft_installation !== SELF_INSTALL;

      if (checkoutButton) checkoutButton.disabled = shouldDisableCheckout;
    }

    /* ------------------------------
       SELF INSTALL
    ------------------------------ */
    if (installationProduct === SELF_INSTALL) {
      const updates = { updates: {} };

      if (cartInstallation) updates.updates[cartInstallation.variant_id] = 0;
      if (cartScotland) updates.updates[cartScotland.variant_id] = 0;

      let updatedCart = cart;

      if (Object.keys(updates.updates).length) {
        updatedCart = await this.updateCart(updates);
      }

      // Remove installation items from DOM
      document
        .querySelector(`.checkout-item-listing [data-variant="${cartInstallation?.variant_id}"]`)
        ?.remove();

      document
        .querySelector(`.checkout-item-listing [data-variant="${cartScotland?.variant_id}"]`)
        ?.remove();

      this.updateTotals(updatedCart);

      setCookie("sft_installation", SELF_INSTALL);

      if (isInstallPage && checkoutButton) checkoutButton.disabled = false;

      this.bindCheckoutValidation();
      return;
    }

    /* ------------------------------
       INSTALLATION SWITCH
    ------------------------------ */
    const updates = { updates: {} };

    if (installationProduct === "installation" && cartScotland) {
      updates.updates[cartScotland.variant_id] = 0;
      document
        .querySelector(`.checkout-item-listing [data-variant="${cartScotland.variant_id}"]`)
        ?.remove();
    }

    if (installationProduct === "installation-scotland" && cartInstallation) {
      updates.updates[cartInstallation.variant_id] = 0;
      document
        .querySelector(`.checkout-item-listing [data-variant="${cartInstallation.variant_id}"]`)
        ?.remove();
    }

    if (VALID_INSTALLATIONS.includes(installationProduct) && sft_installation === SELF_INSTALL) {
      eraseCookie("sft_installation");
    }

    if (!doAdd) {
      this.bindCheckoutValidation();
      return;
    }

    if (!VALID_INSTALLATIONS.includes(installationProduct)) {
      console.warn("Invalid installation product:", installationProduct);
      return;
    }

    /* ------------------------------
       ADD / UPDATE INSTALLATION
    ------------------------------ */
    const installation = await this.getInstallation(installationProduct);
    const variant = installation.variants[0];

    if (trampoline_count > 0) {
      updates.updates[variant.id] = trampoline_count;
    }

    if (Object.keys(updates.updates).length) {
      const updatedCart = await this.updateCart(updates);
      const installItem = updatedCart.items.find((i) => i.handle === installationProduct);
      if (!installItem) return;

      const installationDOM = document.querySelector(
        `.checkout-item-listing [data-variant="${installItem.variant_id}"]`
      );

      if (installationDOM) {
        installationDOM.querySelector(".checkout__num").innerHTML = installItem.quantity;
        installationDOM.querySelector(".price").innerHTML =
          installItem.final_line_price === 0
            ? "FREE"
            : Shopify.formatMoney(installItem.final_line_price);
      } else {
        this.updateInstallation(installItem);
      }

      this.updateTotals(updatedCart);

      if (isInstallPage && checkoutButton) checkoutButton.disabled = false;
    }

    this.bindCheckoutValidation();
  };

  /* ------------------------------
     CHECKOUT VALIDATION
  ------------------------------ */
  this.bindCheckoutValidation = function () {
    const checkoutButton = document.querySelector(".enhance-checkout-cart .btn-checkout");
    const form = checkoutButton?.closest("form");
    if (!form || form.dataset.installationBound) return;

    form.dataset.installationBound = "true";

    form.addEventListener("submit", async function (e) {
      const cart = await fetch("/cart.js").then((r) => r.json());

      const trampoline_count = cart.items.reduce(
        (total, item) =>
          ["trampoline", "Custom Trampoline", "bundle trampoline"].includes(item.product_type)
            ? total + item.quantity
            : total,
        0
      );

      const hasInstallation =
        cart.items.some((i) =>
          ["installation", "installation-scotland"].includes(i.handle)
        ) || getCookie("sft_installation") === SELF_INSTALL;

      if (trampoline_count > 0 && !hasInstallation) {
        e.preventDefault();
        window.location.href = "/pages/select-delivery-installation";
      }
    });
  };

  /* ------------------------------
     HELPERS
  ------------------------------ */
  this.getCart = () => fetch("/cart.js").then((r) => r.json());

  this.updateCart = (itemsToUpdate) =>
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(itemsToUpdate),
    }).then((res) => res.json());

  this.getInstallation = (handle) =>
    fetch("/products/" + handle + ".js").then((r) => r.json());

  this.updateInstallation = (item) => {
    const html = `
      <div class="checkout__item" data-variant="${item.variant_id}">
        <div class="checkout__wrap">
          <div class="checkout__img">
            <span class="checkout__num">${item.quantity}</span>
            <a href="${item.url}">
              <img src="${item.featured_image.url.imgURL("x190")}" loading="lazy" />
            </a>
          </div>
          <div class="checkout__text">
            <span class="checkout__title">${item.title}</span>
          </div>
        </div>
        <div class="checkout__price">
          <span class="price">${
            item.final_line_price === 0
              ? "FREE"
              : Shopify.formatMoney(item.final_line_price)
          }</span>
        </div>
      </div>`;
    document
      .querySelector(".checkout-item-listing .checkout__list")
      ?.insertAdjacentHTML("beforeend", html);
  };

  /* ------------------------------
     AUTO INIT
  ------------------------------ */
  this.init();
};
new InstallationUpdate(null, false, true);

function updateSidebarCart() {
  var quantityInputs = document.querySelectorAll(".checkout__qty select");

  // Attach event listener to each quantity input field

  quantityInputs.forEach(function (quantityInput) {
    quantityInput.addEventListener("change", function () {
      var newQuantity = this.value;
      var parentProduct = this.closest(".checkout__item");
      var variantId = parentProduct.getAttribute("data-variant");
      updateCart(variantId, newQuantity);
    });
  });
}

// Function to update the cart
function updateCart(variantId, newQuantity) {
  var formData = new FormData();
  formData.append("updates[" + variantId + "]", newQuantity);

  fetch("/cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      document.querySelector(".checkout__subtotal-price").innerHTML = Shopify.formatMoney(data.total_price) + " " + data.currency;
      document.querySelector(".checkout__total-price .price").innerHTML = Shopify.formatMoney(data.total_price);
      document.querySelector(".checkout__total .checkout__total-price .price").innerHTML = Shopify.formatMoney(data.total_price);
      let checkoutNum = document.querySelector(`[data-variant="${variantId}"] .checkout__num`);
      let leftSideQty = document.querySelector(`.cart__text-info[data-variant-id="${variantId}"] .qty-input`);

      if (leftSideQty != null) {
        leftSideQty.value = newQuantity;
        if (newQuantity > 1) {
          document
            .querySelector(
              `.cart__text-info[data-variant-id="${variantId}"] .cart__number-prev`
            )
            .classList.remove("disabled");
        } else {
          document
            .querySelector(
              `.cart__text-info[data-variant-id="${variantId}"] .cart__number-prev`
            )
            .classList.add("disabled");
        }
      }

      let updateProduct = document.querySelector(
        `.cart__text-info[data-variant-id="${variantId}"]`
      );
      if (updateProduct != null) {
        updateProduct
          .closest(".cart__item")
          .querySelector(".cart__label").innerHTML = `${newQuantity}  ADDED`;
      }
      checkoutNum.textContent = newQuantity;
      data.items.forEach(function (item) {
        if (item.id == variantId) {
          let price = item.final_line_price;
          document.querySelector(
            `[data-variant="${variantId}"] .price`
          ).textContent = Shopify.formatMoney(price);
        }
      });
    })

    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

document.addEventListener("DOMContentLoaded", function () {
  updateSidebarCart();
  document
    .querySelector(".btn-checkout")
    ?.addEventListener("click", function () {
      this.classList.add("disbaled", "loading");
    });
  document
    .querySelector(".step1 .btn-primary")
    ?.addEventListener("click", function () {
      this.classList.add("disbaled", "loading");
    });
});

window.addEventListener("pageshow", function (event) {
  var historyTraversal =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    // Handle page restore.
    window.location.reload();
  }
});
